import { Button, Card, Select, Table, TableProps } from 'antd'
import clsx from 'clsx'
import { useAccount } from 'wagmi'

import ButtonDownload from 'component/button/button-download'
import LinkAddress from 'component/link/link-address'
import { FEATURE } from 'constants/feature'
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'constants/pagination'
import { ALLOCATION_TITLE } from 'constants/vesting'
import { useVestingContext } from 'context/vesting-context-provider'
import { usePermission } from 'hooks/use-permission'
import { useWeb3ModalHook } from 'hooks/use-web3-modal-hook'
import { useVestingData } from 'hooks/vesting/use-vesting-data'
import ButtonCreate from 'modules/vesting/button-create'
import ButtonImport from 'modules/vesting/button-import'
import ButtonUpload from 'modules/vesting/button-upload'

const ImportWhitelist = () => {
  const { address } = useAccount()

  const { contract, isContractManager, type: vestingType } = useVestingContext()

  const { canCRUD } = usePermission()

  const { handleConnect } = useWeb3ModalHook()

  const {
    loading,
    data,
    total,
    searchParams,
    getData,
    onLoadData,
    onChangeSearchParams,
    handleTableChange,
  } = useVestingData({})

  const { page, limit, ownerAddress, status } = searchParams || {}

  // Define table columns
  const columnsWhitelist: TableProps<any>['columns'] = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => {
        return (
          (Number(page || DEFAULT_PAGE_INDEX) - 1) * Number(limit || DEFAULT_PAGE_SIZE) + index + 1
        )
      },
      width: 70,
      align: 'center',
    },
    {
      title: 'Address',
      dataIndex: 'ownerAddress',
      width: 400,
      key: 'ownerAddress',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <LinkAddress address={text} max={0} />
        </div>
      ),
    },
    {
      title: vestingType ? ALLOCATION_TITLE[vestingType] : 'Allocation',
      width: 200,
      dataIndex: 'allocation',
      key: 'allocation',
    },
    {
      title: 'Amount from File (MEY)',
      width: 200,
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Amount from SmartContract (MEY) ',
      dataIndex: 'amountContract',
      width: 300,
      key: 'amountContract',
      render: (text: any, record: any) => {
        const backgroundColor = loading
          ? 'none'
          : !address
            ? '#2b79f7'
            : record.status
              ? 'green'
              : 'red'

        const value = !address
          ? 'Connect wallet'
          : record?.amountContract
            ? record?.amountContract
            : 0

        return (
          <div
            style={{
              backgroundColor: backgroundColor,
              color: 'white',
              padding: '5px 10px',
              borderRadius: '4px',
              width: 'fit-content',
              cursor: address ? 'unset' : 'pointer',
              display: loading ? 'none' : 'unset',
            }}
            onClick={() => {
              if (!address) handleConnect()
            }}
          >
            {value}
          </div>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      hidden: !address,
      render: (text: any, record: any) => {
        return (
          <>
            <span
              className={clsx({
                'status-pending': !address,
                'status-success': record.status,
                'status-fail': !record.status,
              })}
            >
              {!address
                ? 'Need Import Whitelist'
                : record.status
                  ? 'Valid'
                  : 'Error - Needs to re-import'}
            </span>
          </>
        )
      },
    },
  ]

  return (
    <>
      {canCRUD(FEATURE.VESTING) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'ce',
          }}
        >
          <div className="export-files">
            <ButtonUpload
              disable={!address || !isContractManager}
              //disable={!address}
              onAfterUpload={onLoadData}
            />
            <ButtonDownload />
          </div>
          <div className="export-files">
            <ButtonImport
              disable={!address || !isContractManager}
              onAfterImport={onLoadData}
              contract={contract}
            />
          </div>
        </div>
      )}
      <div className="flex-between">
        <div className="user-search">
          <input
            type="text"
            placeholder="Address"
            value={ownerAddress}
            onChange={(e) => {
              onChangeSearchParams({
                ownerAddress: e.target.value,
                page: DEFAULT_PAGE_INDEX,
              })
            }}
          />
          <Select
            allowClear
            placeholder="By status"
            options={[
              { value: null, label: 'All' },
              { value: false, label: 'Fail' },
              { value: true, label: 'Success' },
            ]}
            value={status}
            onChange={(value) => {
              onChangeSearchParams({
                status: value,
                page: DEFAULT_PAGE_INDEX,
              })
            }}
            style={{ width: '200px', textAlign: 'start' }}
          />
          <Button type="primary" onClick={() => getData(searchParams)}>
            Search
          </Button>
          <ButtonCreate onSubmit={onLoadData} />
        </div>
        <div className="user-action">
          {/* <ButtonImportData onAfterImport={onLoadData} /> */}
          {/* <ButtonCreate onSubmit={onLoadData} /> */}
        </div>
      </div>
      <Card style={{ margin: '0 auto' }}>
        <Table<any>
          rowKey="_id"
          columns={columnsWhitelist}
          dataSource={data}
          loading={loading}
          pagination={
            total < 11
              ? false
              : {
                  total: total,
                  current: page,
                  pageSize: limit,
                }
          }
          onChange={handleTableChange}
          scroll={{ x: 1000 }}
          bordered
        />
      </Card>
    </>
  )
}

export default ImportWhitelist
